<template>
  <section>
    <h4>三樓講堂工作人員</h4>
    <h5>性質：</h5>
    <p>擔任講堂工作(需輪早晚班)、結緣書籍更新補充及建檔、環境清潔維護打掃。</p>
    <h5>條件：</h5>
    <p>
      需受過三皈依，茹素，有基本佛學概念之三寶弟子。<br>
      會操作WORD、EXCEL文書處理。<br>
      願發心服務大眾，能吃苦耐勞，負責盡職，與大眾能和合相處。</p>
    <h5>方式：</h5>
    <p>
      有意應徵者，請將履歷、照片及自傳，<br>
      以面交、E-MAIL或函寄至本會：「台北市杭州南路一段55號３樓」 總務組 楊師姐 收<br>
      電話：<a href="tel:+886-2-23951198">{{ $i18n.locale === 'tw' ? '0' : '+886-' }}2-2395-1198</a>轉35<br>
      傳真：02-2391-3415<br>
      E-mali：<a href="mailto:scyang@budaedu.org">scyang@budaedu.org</a>
    </p>
  </section>
</template>
<script>
import Vue from 'vue'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: "library-staff",
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>